import * as actionType from './DashboardActionType';

export const getDashboardDataRequest = (data) => ({
    type: actionType.GET_DASHBOARD_DATA_REQUEST,
    payload: data,
});
export const getDashboardDataSuccess = (data) => ({
    type: actionType.GET_DASHBOARD_DATA_SUCCESS,
    payload: data,
});
export const getDashboardDataFailure = (error) => ({
    type: actionType.GET_DASHBOARD_DATA_FAILURE,
    payload: error,
});

export const getPortfolioDashboardRequest = (data) => ({
    type: actionType.GET_PORTFOLIO_DASHBOARD_REQUEST,
    payload: data,
});
export const getPortfolioDashboardSuccess = (data) => ({
    type: actionType.GET_PORTFOLIO_DASHBOARD_SUCCESS,
    payload: data,
});
export const getPortfolioDashboardFailure = (data) => ({
    type: actionType.GET_PORTFOLIO_DASHBOARD_FAILURE,
    payload: data,
});
